import React from 'react';
import { buildClassNames } from '../../utils';

import './index.scss';

type As = 'span' | 'p';
export interface TextProps extends React.ComponentProps<'p'> {
  as?: As;
}

export const Text: React.FC<TextProps> = ({ as = 'span', className, ...props }) => {
  const classNames = buildClassNames('chron__text', className);
  return React.createElement(as, { className: classNames, ...props });
};
